"use strict";

var hasOwnProperty = Object.prototype.hasOwnProperty;

module.exports = copy;
function copy(target, source) {
    for (var name in source) {
        if (hasOwnProperty.call(source, name)) {
            target[name] = source[name];
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/collections/copy.js
// module id = 189
// module chunks = 0